<template>
  <iMasonry :min-column-width="160">
    <iStyledCard
      v-for="config in dynamicComponentConfigs"
      :key="config.dynamic_component_id"
      :subtitle="config.rootOptions['display-name'] || config.rootOptions['component-name'] || config.name"
      :splash-image="getComponentScreenshot(config.dynamic_component_id)"
      :splash-image-max-height="200"
      :splash-image-min-height="0"
      :z-index="2"
      selectable
      :focused="activeId === config.dynamic_component_id"
      pointer-cursor-on-hover
      @click="handleSelect(config.dynamic_component_id)"
    />
  </iMasonry>
  <DynamicComponentProductionElement
    v-for="config in dynamicComponentConfigsToPreview"
    :ref="`dynamic-element-preview-${config.dynamic_component_id}`"
    :key="config.dynamic_component_id"
    style="position: absolute; left: 1000%; right: 1000%"
    :dynamic-component-name="config.name"
    :dynamic-component-class="config.classInstance"
    :configuration="config.compiledConfiguration"
    :dynamic-component-id="config.dynamic_component_id"
    element-id="null"
    @on:mount="getScreenshot(config.dynamic_component_id)"
  />
</template>

<script>
import { mapActions, mapWritableState } from "pinia";
import useDynamicComponentStore from "%/dynamic-component-editor/stores/dynamic-component-store";
import { useComponentScreenshot } from "~/helpers/component-screenshot-helper";
import DynamicComponentProductionElement
  from "%/dynamic-component-editor/components/DynamicComponentProductionElement.vue";

export default {
  name: "DynamicComponentPreviewGrid",
  components: { DynamicComponentProductionElement },
  props: {
    ids: {
      type: Array,
      required: true,
    },
    activeId: {
      type: Number,
      default: 0,
      required: false,
    },
    useBlank: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  emits: ["select"],
  data() {
    return {
      dynamicComponentConfigs: [],
      dynamicComponentConfigsToPreview: [],
      screenshot: null,
    };
  },
  computed: {
    ...mapWritableState(useDynamicComponentStore, [
      "componentScreenshots",
    ]),
  },
  watch: {
    ids: {
      immediate: true,
      handler() {
        this.getDynamicComponentConfigs();
      },
    },
  },
  mounted() {
    this.screenshot = useComponentScreenshot({
      scale: 2,
      maxWidth: 400,
    });
  },
  methods: {
    ...mapActions(useDynamicComponentStore, [
      "getDynamicComponentConfigFromHierarchy",
      "getOrImportDynamicComponentClass",
    ]),
    handleSelect(dynamicComponentId) {
      this.$emit("select", dynamicComponentId);
    },
    async getScreenshot(dynamicComponentId) {
      if (!this.componentScreenshots[dynamicComponentId]) {
        const blobUrl = await this.screenshot.captureComponent(
          this.$refs[`dynamic-element-preview-${dynamicComponentId}`][0],
        );
        this.componentScreenshots[dynamicComponentId] = blobUrl;
      }
    },
    async getDynamicComponentConfigs() {
      this.dynamicComponentConfigs = [];
      for (let i = 0; i < this.ids.length; i++) {
        const dynamicComponentId = this.ids[i];

        const configuration = this.getDynamicComponentConfigFromHierarchy(dynamicComponentId);
        if (!configuration) {
          continue;
        }
        this.dynamicComponentConfigs.push(configuration);
      }

      if (this.useBlank) {
        this.dynamicComponentConfigs.unshift({
          dynamic_component_id: 0,
          rootOptions: {
            "display-name": "Blank Template",
          },
        });
      }
    },
    getComponentScreenshot(dynamicComponentId) {
      return this.componentScreenshots[dynamicComponentId] ||
          "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/empty-template.jpg";
    },
  },
  styleGuide: () => ({}),
};
</script>

<style scoped lang="scss">
.template-elements {
  position: fixed;
  left: -100000%;
  top: -100000%;
}
</style>
